// @flow
import React from 'react';
import { FooterLink } from 'components/atoms/footerLink';
import type {
  FooterLinkProps,
  FooterLinkType,
} from 'components/atoms/footerLink';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  links: Array<FooterLinkProps>,
  type?: FooterLinkType,
};

export const CustomFooterMenu = (props) => {
  const { links, type } = props;
  return (
    <ul className={'footer-menu'}>
      {links && links.map((link, index) => {
        return (
          <li key={index}>
            <FooterLink
              title={link.name}
              link={link.link}
              type={type}
            />
          </li>
        );
      })}
    </ul>
  );
};
